import { defineModule } from '../types.js';
export default defineModule({
    id: 'justificatifs',
    nom: 'Justificatifs',
    description: 'Suit les pièces des opérations bancaires : à justifier, à catégoriser, dispensées par une règle validée, et mois rapprochés. Collecte aussi les factures reçues par courriel (FreeScout, Gmail) et les dépose, après validation, dans le Drive. Lecture seule dans Zoho.',
    famille: 'exercice',
    dependances: ['exercice'],
    activableParDefaut: true,
    desactivable: true,
    routesApi: ['/api/justificatifs'],
    droits: {
        'justificatifs.consulter': { description: 'Voir l’état des justificatifs et les règles de dispense', niveau: 'lecture' },
        'justificatifs.gerer': { description: 'Créer, valider et désactiver les règles de dispense', niveau: 'administration' },
        'justificatifs.collecter': {
            description: 'Traiter les pièces reçues, gérer les règles de collecte, lancer une campagne',
            niveau: 'administration',
        },
    },
    navigation: [
        {
            cle: 'justificatifs',
            libelle: 'Justificatifs',
            picto: '⎘',
            groupe: 'Exercice en cours',
            ordre: 16,
            droit: 'justificatifs.consulter',
        },
    ],
    reglages: {
        semaines_suivi: { type: 'nombre', libelle: 'Semaines affichées dans le suivi', defaut: 12, min: 2, max: 52 },
        titulaires_cartes: {
            type: 'texte',
            libelle: 'Titulaires des cartes bancaires',
            defaut: '4179:Yannis Jean,2200:Yannis Jean,9660:Ariane Pouget,7430:Marielle Pautonnier',
            aide: 'Liste séparée par des virgules : <4 derniers chiffres>:<nom>. Dit à qui demander la pièce d’un paiement par carte.',
        },
        depot_actif: {
            type: 'booleen',
            libelle: 'Déposer les pièces dans le Drive',
            defaut: false,
            aide: 'À blanc tant que faux : la campagne propose, rien n’est déposé.',
        },
        jev_collecte: {
            type: 'booleen',
            libelle: 'Lire les pièces avec Jev',
            defaut: true,
            aide: 'Jev ne reçoit jamais le texte d’une pièce captée par une règle « jamais envoyée à Jev ».',
        },
        conservation_jours: {
            type: 'nombre',
            libelle: 'Conservation des fichiers en attente',
            defaut: 90,
            min: 7,
            max: 365,
            unite: 'jours',
            aide: 'Délai après dépôt ou écart, avant effacement du fichier local.',
        },
        date_debut_collecte: {
            type: 'texte',
            libelle: 'Date de début de la collecte',
            defaut: '2026-01-01',
            aide: 'Format AAAA-MM-JJ : les messages antérieurs ne sont pas collectés.',
        },
        sources: {
            type: 'texte',
            libelle: 'Sources de la collecte',
            defaut: 'freescout:2,freescout:1,gmail:yannis.jean@compagnies.org',
            aide: 'Liste séparée par des virgules : freescout:<identifiant de boîte> ou gmail:<adresse>.',
        },
    },
});
//# sourceMappingURL=justificatifs.js.map